import { render, staticRenderFns } from "./DashView.vue?vue&type=template&id=4c9cf349"
import script from "./DashView.vue?vue&type=script&lang=ts"
export * from "./DashView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports